export interface ILateCryo {
    requestedDate: string,
    xmStatusDeadline: string,
    resultsRecordedDate: string,
    recipientAlias: string,
    donorAlias: string
}